import { createAccessoryTypes, updateAccessoryTypes } from 'api/accessoryTypes';

import type { FormType } from '..';

export const accessoryTypeForm: FormType = {
  createFn: createAccessoryTypes,
  updateFn: updateAccessoryTypes,
  cancelText: 'Cancelar',
  submitText: 'Salvar Acessório',
  disableText: 'Excluir Acessório',
  successText: 'Acessório salvo com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Nome do tipo',
          label: 'Nome:',
        },
      },
    ],
  ],
};
